<script>
  import { trackLinkClick } from '../../../../../../../../../js/trackLinkClick';

  import SpotlightImage from './SpotlightImage/SpotlightImage.svelte';
  import ArrowLink from './ArrowLink/ArrowLink.svelte';

  // Props
  export let id = '';
  export let image = null;
  export let url = '';
  export let linkText = '';
</script>

<div {id} class="SpotlightItem">
  <a
    {id}
    href={url}
    use:trackLinkClick={{
      id,
      title: linkText,
      url,
    }}
  >
    {#if image}
      <SpotlightImage id={image.id} description={image.description} url={image.url} />
    {/if}
  </a>
  <ArrowLink {id} {linkText} {url} />
</div>

<style>.SpotlightItem {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}</style>
